import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {LoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {MonkeysGoldColossalSpine} from "./MonkeysGoldColossalSpine";

/**
 * Created by Jerker Nord on 2020-06-12.
 */

export class MonkeysGoldColossalUpgradeAnimationController {

    private _spineSymbols2x2:MonkeysGoldColossalSpine[];
    private _spineSymbols3x3:MonkeysGoldColossalSpine[];

    constructor() {
        EventHandler.addEventListener(this, LoaderEvent.RESOURCES_LOADED, (event:LoaderEvent) => this.onResourcesLoaded(event));
    }

    private onResourcesLoaded(event:LoaderEvent):void {
        if(event.key != ResourcesGroupName.MAIN) {
            return;
        }

        //Create and position the 2x2 spine turn symbols
        let row:number = 1;
        this._spineSymbols2x2 = [];
        for(let i:number = 0; i < 3; i++) {
            let reel:number = 1;
            for(let j:number = 0; j < 3; j++) {
                const spineSymbol:MonkeysGoldColossalSpine = new MonkeysGoldColossalSpine(GameResources.getSpineAsset("spineSymbolTurn2x2"));
                spineSymbol.visible = false;
                spineSymbol.position.x -= GameConfig.instance.SYMBOL_WIDTH / 2;
                spineSymbol.position.y -= GameConfig.instance.SYMBOL_HEIGHT / 2;
                reel += 2;
                this._spineSymbols2x2.push(spineSymbol);
            }
            row += 2;
        }

        //Create and position the 3x3 spine turn symbols
        row = 2;
        this._spineSymbols3x3 = [];
        for(let i:number = 0; i < 2; i++) {
            let reel:number = 2;
            for(let j:number = 0; j < 2; j++) {
                const spineSymbol:MonkeysGoldColossalSpine = new MonkeysGoldColossalSpine(GameResources.getSpineAsset("spineSymbolTurn3x3"));
                spineSymbol.visible = false;
                spineSymbol.position.x -= GameConfig.instance.SYMBOL_WIDTH;
                spineSymbol.position.y -= GameConfig.instance.SYMBOL_HEIGHT;
                reel += 3;
                this._spineSymbols3x3.push(spineSymbol);
            }
            row += 3;
        }
    }

    // @ts-ignore
    public get2x2UpgradeAnimation():MonkeysGoldColossalSpine {
        for(let i:number = 0; i < this._spineSymbols2x2.length; i++) {
            if(this._spineSymbols2x2[i].inUse == false) {
                this._spineSymbols2x2[i].inUse = true;
                return this._spineSymbols2x2[i];
            }
        }
    }

    // @ts-ignore
    public get3x3UpgradeAnimation():MonkeysGoldColossalSpine {
        for(let i:number = 0; i < this._spineSymbols3x3.length; i++) {
            if(this._spineSymbols3x3[i].inUse == false) {
                this._spineSymbols3x3[i].inUse = true;
                return this._spineSymbols3x3[i];
            }
        }
    }
}